import { useLanguage } from "@/i18n/LanguageContext";

export default function PhotoDivider() {
  const { t } = useLanguage();

  return (
    <section className="relative h-[48vh] overflow-hidden md:h-[62vh]" data-testid="photo-divider">
      <img
        src="/assets/event-coffee.jpg"
        alt={t("divider.caption")}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-black/55" />
      <div className="absolute inset-0 flex items-end">
        <div className="mx-auto w-full max-w-[1440px] px-6 pb-10 md:px-12 md:pb-14">
          <p className="font-spacemono text-[10px] uppercase tracking-[0.35em] text-white/80">
            <span className="text-[#F97316]">(—)</span>&nbsp;&nbsp;{t("divider.caption")}
          </p>
        </div>
      </div>
    </section>
  );
}
